<template>
    <div>
        <button
            v-if="active"
            class="w-full flex items-center justify-between border-b-2 hover:text-success"
            :aria-expanded="isOpen"
            :aria-controls="`collapse-${uid}`"
            @click="toggleAccordion()"
        >
            <slot name="title" />
            <svg
                class="mb-1 transition-all duration-200 transform"
                :class="{ 'rotate-45': isOpen, 'rotate-0' : !isOpen }"
                width="18"
                height="18"
                viewBox="0 0 18 18"
                fill="currentColor"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    d="M7.39489 17.0838V0H9.70242V17.0838H7.39489ZM0 9.68892V7.39489H17.0973V9.68892H0Z"
                    fill="currentColor"
                />
            </svg>
        </button>

        <span v-else class="w-full flex items-center justify-between border-b-2 hover:text-success text-gray-500">
            <slot name="title" />
        </span>

        <div
            v-show="isOpen"
            :id="`collapse-${uid}`"
        >
            <slot name="content" />
        </div>
    </div>
</template>

<script>

export default {
    props: {
        active: {
            type: Boolean,
            default: true
        }
    },
    data() {
        return {
            isOpen: false,
            uid: Math.random().toString(36).substr(2, 10)
        };
    },

    methods: {
        toggleAccordion() {
            this.isOpen = !this.isOpen;
            if(this.isOpen) this.$emit('opened')
            else this.$emit('closed')
        },
    },
};
</script>
